import { z } from '@qred/components-library';
import { validatePersonalNumber } from '@qred/shared-component-library/src/validators';
import { BelgiumClientAssessment } from './LegalQuestions.utils';
import { CountryCode } from '~/enums';

const {
  IsMarried,
  HasPrenuptialAgreement,
  HasOtherDebt,
  OtherDebtAmount,
} = BelgiumClientAssessment;

export const createLegalQuestionsFormSchema = (market: CountryCode) => {
  const debtsFormSchema = z.union([
    z.object({
      hasOtherDebt: z.literal(HasOtherDebt.answerNo.id),
    }),
    z.object({
      hasOtherDebt: z.literal(HasOtherDebt.answerYes.id),
      otherDebtAmount: z
        .literal(OtherDebtAmount.answer1000To50000.id)
        .or(z.literal(OtherDebtAmount.answer50001To100000.id))
        .or(z.literal(OtherDebtAmount.answer100001To250000.id))
        .or(z.literal(OtherDebtAmount.answer250001To500000.id))
        .or(z.literal(OtherDebtAmount.answer500000Plus.id)),
    }),
  ]);

  const spouseFormSchema = z.object({
    firstName: z
      .string()
      .trim()
      .min(1, { message: 'ValidationErrors.Required' }),
    lastName: z
      .string()
      .trim()
      .min(1, { message: 'ValidationErrors.Required' }),
    personalNumber: z
      .string()
      .trim()
      .min(1, { message: 'ValidationErrors.Required' })
      .refine((value) => validatePersonalNumber(value, market), {
        message: 'ValidationErrors.PersonalNumber',
      }),
    address: z.string().trim().min(1, { message: 'ValidationErrors.Required' }),
  });

  return z.union([
    z
      .object({
        isMarried: z.literal(IsMarried.answerNo.id),
      })
      .and(debtsFormSchema),
    z
      .object({
        isMarried: z.literal(IsMarried.answerYes.id),
        hasPrenuptialAgreement: z.literal(HasPrenuptialAgreement.answerYes.id),
      })
      .and(debtsFormSchema),
    z
      .object({
        isMarried: z.literal(IsMarried.answerYes.id),
        hasPrenuptialAgreement: z.literal(HasPrenuptialAgreement.answerNo.id),
        spouse: spouseFormSchema,
      })
      .and(debtsFormSchema),
  ]);
};

type LegalQuestionsFormSchema = ReturnType<
  typeof createLegalQuestionsFormSchema
>;
export type LegalQuestionsForm = z.infer<LegalQuestionsFormSchema>;
